import { render, staticRenderFns } from "./EditWork.vue?vue&type=template&id=290fc7b4&scoped=true&"
import script from "./EditWork.vue?vue&type=script&lang=js&"
export * from "./EditWork.vue?vue&type=script&lang=js&"
import style0 from "./EditWork.vue?vue&type=style&index=0&id=290fc7b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290fc7b4",
  null
  
)

export default component.exports